import { DialogDisclosure } from 'reakit/Dialog';
import styled from 'styled-components';

export const OpenMediaModalButton = styled.button`
  background: none;
  width: 100%;
  border: none;
  height: 100%;
  position: absolute;
  cursor: pointer;
  z-index: 1;
`;
